import styled from 'styled-components';

export const StyledNav = styled.nav`
  width: 100%;
`;
